import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { SecGroupDescriptor } from './model/secgroup';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class SecGroupService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'SecGroupManagement',
      authService,
      config.SGMSConfig
    );
  }

  public create(label: SecGroupDescriptor): Promise<SecGroupDescriptor> {
    return super.post<SecGroupDescriptor>(
      new SecGroupDescriptor({
        id: undefined,
        href: undefined,
        name: label.name,
        description: label.description,
        modified: label.modified,
        deleted: label.deleted
      }));
  }

  public getSecGroups(view?: View): Promise<List<SecGroupDescriptor>> {
    return super.get<List<SecGroupDescriptor>>(undefined, view);
  }

  async GetList(v: View): Promise<List<SecGroupDescriptor>> {
    return await this.getSecGroups(v);
  }
  async GetById(id: string): Promise<SecGroupDescriptor> {
    return await this.getById(id);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, role: SecGroupDescriptor): Promise<SecGroupDescriptor> {
    return super.put<SecGroupDescriptor>(id, role);
  }

  public getById(id: string): Promise<SecGroupDescriptor> {
    return super.get<SecGroupDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/secgroup/secgroup.service.ts